import * as yup from "yup";

import { IAccountDetailsSettings } from "../../interfaces-and-types";

export const accountDetailsValidationSchema: yup.SchemaOf<IAccountDetailsSettings> =
  yup
    .object({
      merchant_name: yup.string().nullable().required(),
      merchant_handle: yup
        .string()
        .trim()
        .matches(/^[a-zA-Z0-9]+$/, "Only alphanumeric characters are allowed")
        .nullable()
        .required("Please enter a unique handle for your profile"),
      bvn: yup
        .string()
        .trim()
        .nullable()
        .optional()
        .when("country", {
          is: (country: string) => country === "NG",
          then: yup
            .string()
            .typeError("Please enter a valid value")
            .required("BVN is required for Nigerian merchants.")
            .min(11)
            .max(11),
        }),
      nin: yup.string().trim().nullable().optional(),

      country: yup.string().nullable().required(),
      phone_number: yup.string().nullable().required(),
      time_zone: yup.string().nullable().required(),
      account_status: yup.string().nullable().required(),
    })
    .required();
